<div class="container">
  <div class="container-client">
    <div class="header">
      <h1 class="title">{{'PROJECTS' | translate}}</h1>
      <button class="btn btn-outline-primary primary-btn" (click)="setCreatingProjects()">{{'CREATE' | translate}}</button>
    </div>

    <div class="form-card">
      <div class="loading" *ngIf="loading">
        <div class="spinner-border" role="status"></div>
      </div>

      <div *ngIf="showNoProjectsMessage && !loading" class="no-orders">
        <span> {{'NO_PROJECTS' | translate}}</span>
      </div>

      <table *ngIf="!loading && projects.length > 0" class="table table-bordered table-hover">
        <thead>
            <th scope="col" class="table-start">{{'PROJECT_NAME' | translate}}</th>
            <th scope="col"> {{'PROJECT_ID' | translate}}</th>
            <th scope="col"> {{'EDIT' | translate}}</th>
            <th scope="col" class="table-end"> {{'DELETE' | translate}}</th>
        </thead>
        <tbody>
          <tr *ngFor="let project of projects">
            <td>{{ project.projectName || 'Sin nombre' }}</td>
            <td>{{ project.projectId }}</td>
            <td>
              <button type="button" class="primary-btn" (click)="editProject(project.externalId)">
                {{'EDIT' | translate}}
              </button>
            </td>
            <td>
              <button class="btn btn-primary remove-btn" (click)="deleteProject(project.projectId, project.timekitProjectId)">
                {{'DELETE' | translate}}
              </button>
              </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="modal client-confirm-modal" id="successDeleteProjectModal" tabindex="-1">
  <div class="modal-dialog client-modal-dialog" role="document">
    <div class="modal-content client-modal-content">
      <div class="modal-body client-modal-body">
        <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
        <p class="text-center">{{'PROJECT_DELETE_SUCCESS' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeSuccessModal()">{{'CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal error-confirm-modal fade" id="errorDeleteProjectModal" tabindex="-1">
  <div class="modal-dialog error-modal-dialog" role="document">
    <div class="modal-content error-modal-content">
      <div class="modal-body error-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{'ERROR_DELETE_PROJECT' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>
